define.alias("shared/utils/array-filters/get-first-point-by-name", "settings/utils/array-filters/get-first-point-by-name");